import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AssignNewProducts from '../../components/blocks/AssignNewProducts';
import Spinner from '../../components/common/Spinner';
import Toolbar from '../../components/common/Toolbar';

import {
  getProductsDropship,
  setProductsDropshipOffset,
  setProductsDropshipCurrentFilter,
  getProductsDropshipRetailers,
  productsDropshipCheck,
  productsDropshipUncheck,
  setProductsDropshipSearch,
  productsDropshipSubmit,
} from '../../store/actions/productsDropship';

import { setProductFiltersSearch } from '../../store/actions/productFilters';
import { getSupplierProductFilters } from '../../store/actions/suppliers';
import { StaticFilters } from '../../constants/staticFilters';

function ProductsDropshipContainer(props) {
  const { getProductsFilters, getProducts, getProductsRetailers } = props;

  useEffect(() => {
    getProductsFilters();
    getProducts();
    getProductsRetailers();
  }, [getProductsFilters, getProducts, getProductsRetailers]);

  if (props.isLoading) {
    return <Spinner />;
  }

  const staticFilters = [
    StaticFilters.HAS_INVENTORY,
    StaticFilters.ASSIGNED_TO_RETAILERS,
    StaticFilters.ACTIVE_PRODUCTS,
  ];

  return (
    <div>
      <Toolbar name="Catalogue Management" />
      <AssignNewProducts staticFilters={staticFilters} {...props} />
    </div>
  );
}

const mapStateToProps = (state) => {
  const { data, count, retailers, checked, perPage, search, offset, isLoading, isLoadingProducts } =
    state.productsDropship;
  const canUserDoActions = state.role?.user?.is_super_admin && ['support', 'admin'].includes(state.role?.user?.role);
  const { filters, currentFilters, currentFilterSearches } = state.productFilters;

  return {
    data,
    retailers,
    checked,
    perPage,
    offset,
    isLoading,
    isLoadingProducts,
    searchQuery: search,
    filters,
    currentFilters,
    currentFilterSearches,
    pageCount: Math.ceil(count / perPage),
    canUserDoActions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getProducts: () => dispatch(getProductsDropship(false)),
  setPage: (offset) => dispatch(setProductsDropshipOffset(offset)),
  getProductsFilters: () => dispatch(getSupplierProductFilters()),
  setFilter: (filter) => dispatch(setProductsDropshipCurrentFilter(filter)),
  setFilterSearch: (filter, search) => dispatch(setProductFiltersSearch(filter, search)),
  getProductsRetailers: () => dispatch(getProductsDropshipRetailers()),
  check: (id) => dispatch(productsDropshipCheck(id)),
  uncheck: (id) => dispatch(productsDropshipUncheck(id)),
  productSearch: (search) => dispatch(setProductsDropshipSearch(search)),
  submit: (value) => dispatch(productsDropshipSubmit(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsDropshipContainer);

ProductsDropshipContainer.defaultProps = {
  checked: {},
};

ProductsDropshipContainer.propTypes = {
  setPage: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  retailers: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  getProductsFilters: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  setFilterSearch: PropTypes.func.isRequired,
  getProductsRetailers: PropTypes.func.isRequired,
  check: PropTypes.func.isRequired,
  uncheck: PropTypes.func.isRequired,
  productSearch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  checked: PropTypes.object,
};
